import React from 'react';
import * as Formatting from 'fw/misc/Formatting'

class ClientDateTime extends React.Component {
	shouldComponentUpdate(nextProps) {
		return (
			nextProps.value !== this.props.value);
	}

	render() {
        return <React.Fragment>{Formatting.formatClientDateTime(this.props.value)}</React.Fragment>
    }
}

export default ClientDateTime;


// WEBPACK FOOTER //
// ./src/fw/components/formatter/ClientDateTime.js